// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604130831/js/" + chunkId + "." + {"44":"8db8d448","225":"cf5f2ac2","481":"90dd73e8","486":"7b944bb5","770":"941cef63"}[chunkId] + ".0.6052400330046357.chunk.js";
};